import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Tooltip,
    Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import usePendingAssignments from '../../../../api/blockchain/usePendingAssignments';
import { useState } from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import { CircularProgress } from '@mui/material';
import { snackbar } from '../../../../utilities/snackbarUtils';
import cancelDistribution from '../../../../api/blockchain/distributions/cancel';
import BCTable from '../Utils/BCTable';
import DataLoading from '../Utils/DataLoading';

const AssignmentActions = ({assetUuid, distributionId, onActionFinished}) => {

    const [ submitting, setSubmitting ] = useState(undefined);

    const doAction = async (label, action) => {
        setSubmitting(label.toLowerCase());
        try {
            await action(assetUuid, distributionId);
            snackbar.success(`${label} finished successfully`);
            onActionFinished();
        } catch (error) {
            snackbar.error(`Failed to ${label} distribution`);
        } finally {
            setSubmitting(undefined);
        }
    }
    
    return <>
        <IconButton variant="outlined" size="small"
            sx={{ marginRight: '10px;' }}
            onClick={() => doAction('Cancel', cancelDistribution)}
            disabled={!!submitting}
        >
            <Tooltip title="Cancel distribution">
                {submitting === 'cancel' ? <CircularProgress /> : <DeleteIcon /> }
            </Tooltip>
        </IconButton>
    </>
}

const ViewPendingAssignmentsDialog = ({ open, handleClose, assetUuid }) => {
    const theme = useTheme();
    const {
        pendingAssignments,
        pendingAssignmentsLoading,
        updatePendingAssignments
    } = usePendingAssignments(assetUuid);

    return (
        <Dialog
            open={open}
            onClose={() => {
                handleClose();
            }}
            maxWidth="lg"
        >
            <DialogTitle>Asset Distribution Assignments</DialogTitle>
            <DialogContent>
                <div style={{ display: 'flex', color: theme.palette.text.secondary }}>
                    <Typography variant="body2">
                        Manage the pending assigments for distributions
                    </Typography>
                </div>
                <DataLoading 
                    loading={pendingAssignmentsLoading}
                    text='Loading assignments...'
                />

                {
                    (!pendingAssignmentsLoading && pendingAssignments) &&
                    <BCTable
                        columns={[
                            { name: 'investor_name', label: 'Holder', bold: true },
                            { name: 'amount', label: 'Assignment Amount', type: 'amount' },
                            {
                                name: 'actions', label: 'Actions', type: 'actions', render: (assignment) => (
                                    <AssignmentActions 
                                        assetUuid={assetUuid}
                                        distributionId={assignment.distributionUuid}
                                        onActionFinished={updatePendingAssignments}
                                    />
                                )
                            },
                        ]}
                        data={pendingAssignments}
                    />
                }
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ViewPendingAssignmentsDialog;
